import { Flex, useToast } from '@chakra-ui/react';
import { LocationCredentialsTable } from './LocationCredentialsTable';
import { useGetLocationCredentials, useSaveLocationCredentials } from '../../hooks/useLocationCredentials';

interface MitchellLoginsStepProps {
	organizationId: string;
	locations: Array<{ _id: string; title: string }>;
	onNext: () => void;
	onSkip: () => void;
	onBack?: () => void;
	isUploadOpen?: boolean;
	onCloseUpload?: () => void;
}

export const MitchellLoginsStep = ({
	organizationId,
	locations,
	onNext,
	onSkip,
	onBack,
	isUploadOpen,
	onCloseUpload,
}: MitchellLoginsStepProps) => {
	const toast = useToast();
	const saveCredentials = useSaveLocationCredentials();
	const existingCredentials = useGetLocationCredentials(organizationId, 'mitchell');

	const initialUsernames = Object.fromEntries(
		(existingCredentials.data ?? []).map((item) => [item.locationId, item.username])
	);

	return (
		<Flex direction="column" gap={4} flex={1} minH={0}>
			<LocationCredentialsTable
				locations={locations}
				provider="mitchell"
				initialUsernames={initialUsernames}
				isLoading={saveCredentials.isPending}
				onSkip={onSkip}
				onBack={onBack}
				isUploadOpen={isUploadOpen}
				onCloseUpload={onCloseUpload}
				onSave={async (credentials) => {
					if (credentials.length === 0) {
						onSkip();
						return;
					}
					await saveCredentials.mutateAsync({
						organizationId,
						provider: 'mitchell',
						credentials,
					});
					toast({
						title: 'Mitchell credentials saved',
						status: 'success',
						duration: 3000,
						isClosable: true,
					});
					onNext();
				}}
			/>
		</Flex>
	);
};

